import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Field } from '../../model/formBuilderInterface';
import { DEFAULT_DATE_FORMAT_Y } from 'src/app/constants/constant';
@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss']
})
export class FormDatePickerComponent {
  @Input() field: Field;
  @Input() form: FormGroup;
  dateFormat = DEFAULT_DATE_FORMAT_Y;

  get bsConfig(): Record<string, unknown> {
    const fmt = this.field.dateInputFormat || this.dateFormat;
    return {
      dateInputFormat: fmt,
      adaptivePosition: true,
      ...(this.field.bsStartView ? { startView: this.field.bsStartView } : {})
    };
  }
}
